import { TOGGLE_TASK_STATUS } from "@/components/tasks/ducks/Actions"
import { apiToggleTaskStatus } from "@/components/tasks/ducks/AJAX"
import receiveUpdateSuccessWithTasks from "@/components/tasks/helpers/receiveUpdateSuccessWithTasks"

export default (_store) => (next) => (action) => {
  // const { dispatch } = store

  switch (action.type) {
    case TOGGLE_TASK_STATUS:
      apiToggleTaskStatus(
        action.params,
        receiveUpdateSuccessWithTasks(action.success),
        action.error,
      )
      return next(action)

    // case NavigationActions.clearSuffixLink.type: {
    //   dispatch(unmountTask())
    //   return next(action)
    // }
    default:
      return next(action)
  }
}
